import { DedicateMotoboy } from '@/_features/motoboys/dedicate-motoboy';

function PageDedicateMotoboy() {
  return (
    <div className="container">
      <DedicateMotoboy />
    </div>
  );
}

export default PageDedicateMotoboy;
